var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-lab-order-detail',{ref:"detail",staticClass:"pt-lab-order-detail__page",attrs:{"id":_vm.id,"value":_vm.value}})}
var staticRenderFns = []

export { render, staticRenderFns }